import script from "./AiCanvas.vue?vue&type=script&lang=ts&setup=true"
export * from "./AiCanvas.vue?vue&type=script&lang=ts&setup=true"

import "./AiCanvas.scss?vue&type=style&index=0&id=184ee7ad&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-184ee7ad"]])

export default __exports__